/* eslint no-nested-ternary: 0 */
/* eslint no-lone-blocks: 0 */
import React from 'react'
import Icon from '../../../../components/icon'

import {
  Container,
  OrderId,
  CreatedAt,
  Footer,
  PartialWrapper,
} from './styles'
import { If } from '../../../../components/if/if'
import { formatDate } from '../../../../helpers/helper-date'
import {
  tableOrderStatusLabel,
} from '../../../../helpers/helper-order'
import OrderPad from '../order-pad'

import { OrderStatusCard, OrderStatusHeader } from '../order-pad/styles'
import { useOrder } from '../../../../contexts/order'
import CloseOrderPadModal from '../close-order-pad-modal'

const OrderDetails = () => {
  const { orderPad, setOrderPadIsOpen, currentOrderPadCard } = useOrder()

  if (!orderPad || !currentOrderPadCard) return <></>

  return (
    <Container>
      <OrderStatusCard>
        <OrderStatusHeader code={currentOrderPadCard.status}>
          <h2>{tableOrderStatusLabel[(currentOrderPadCard.status as 0 | 1 | 2)]}</h2>
        </OrderStatusHeader>
        <div>
          <OrderId>
            {`Mesa: ${orderPad.stablishmentTable.name} `}
          </OrderId>

          <CreatedAt>
            <Icon name="time-atack" />
            <p>
              Iniciou em
              {formatDate(orderPad.createdAt, ' DD/MM ')}
              às
              {formatDate(orderPad.createdAt, ' HH:mm')}
            </p>
          </CreatedAt>
        </div>
      </OrderStatusCard>

      <OrderPad />

      <Footer>
        <button
          type="button"
          disabled={!currentOrderPadCard.isUniqueOrderWrapper}
          onClick={() => setOrderPadIsOpen(true)}
        >
          Fechar a conta
        </button>

        <If condition={!currentOrderPadCard.isUniqueOrderWrapper}>
          <PartialWrapper>
            <div className="alert">
              <p>
                Este cliente solicitou o
                <br />
                pagamento parcial
              </p>
            </div>
            <button
              type="button"
              onClick={() => setOrderPadIsOpen(true)}
            >
              Fechar a conta - Parcial
            </button>
          </PartialWrapper>
        </If>
      </Footer>
      <CloseOrderPadModal />
    </Container>
  )
}

export default OrderDetails
